export default __webpack_public_path__ + "static/media/undraw_Inbox_cleanup_re_jcbh.b198730b.png";